/**
 * Consent status — pure, data-driven helpers for the consent flow.
 *
 * The backend consent agent writes `interviewee_consent_obtained`
 * ('Yes' | 'No' | '<UNKNOWN>') onto the session — pushed live via the
 * `field_update` websocket message (merged into extracted_fields) or read from
 * the fetched session. These helpers derive what the consent window renders
 * straight from that value (no React state). Consent is only ever granted by the
 * agent — there is no manual "mark acquired" path.
 */
import { Session } from '../../../store/sessionSlice';

export type ConsentStatus = 'pending' | 'acquired' | 'declined';

/** Effective consent value: a manual override wins over the LLM extraction. */
export const selectConsentValue = (session?: Session | null): string | undefined =>
  (session?.human_overrides_fields?.interviewee_consent_obtained
    || session?.extracted_fields?.interviewee_consent_obtained) as string | undefined;

/** Map the raw backend value → the status the consent window renders from. */
export const deriveConsentStatus = (value?: string): ConsentStatus =>
  value === 'Yes' ? 'acquired' : value === 'No' ? 'declined' : 'pending';
